<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup >
// props="['width','height','right1Data']"
name: "baseBar";
import { ref, onMounted,defineProps } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  leftData3: {
    type: Array,
    default: () => [],
  },
})
// console.log(props.leftData2);
const myEcharts = ref(null);

onMounted(() => {
  initChart(props.leftData3);
});

function initChart(leftData3) {
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }

  const chartInstance = echarts.init(myEcharts.value);
  const xLabel = leftData3[0]
  let yValue = leftData3[1]
  let max = Math.max(...yValue);
  let number = xLabel.length
  const maxArry = new Array(number).fill(max);
  const option= {
    grid: {
        top: "15%",
        bottom: "10%" ,
        left:"8%"
    },
    xAxis: {
        data: xLabel,
        axisLine: {
            show: true,
            lineStyle: {
                color: "#0A464F"
            }
        },
        axisTick: {
            show: false //隐藏X轴刻度
        },
        axisLabel: {
            margin: 10,
            textStyle: {
                fontSize: 14,
                color: "#DEEBFF" //X轴文字颜色
            }
        }
        },
        yAxis: [
            {
                type: "value",
                name: "mm",
                axisLine: {
                    show: true,
                    lineStyle: {
                    color: "#0A464F"
                    }
                },
                splitLine: {
                    show: false,
                    lineStyle: {
                    color: ['rgba(255,255,255,0.3)']
                    }
                },
                nameTextStyle: {
                    color: "#DEEBFF",
                    fontSize: 14,
                    lineHeight: 0
                },
                axisLabel: {
                    show: true,
                    margin: 2,
                    fontSize: 14,
                    textStyle: {
                    color: "#DEEBFF"
                    }
                }
            }
        ],
        series: [
            {
                type: "bar",
                barWidth: 12,
                itemStyle: {
                    color: (params) => ({
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                        {
                            offset: 0,
                            color: "#FEA000" // 柱子最高度% 处的颜色
                        },
                        {
                            offset: 1,
                            color: "#F0E203" // X轴处的颜色
                        }
                    ],
                    global: false // 缺省为 false
                    })
                },
                data: leftData3[1],
                z: 10,
                zlevel: 2
            },
            {
                // 值分隔
                type: "pictorialBar",
                itemStyle: {
                    normal: {
                    color: "#0F375F"
                    }
                },
                symbolRepeat: "fixed",
                symbolMargin: 3,
                symbol: "rect",
                symbolClip: true,
                symbolSize: [16, 3],
                symbolPosition: "start",
                symbolOffset: [0, 0],
                // symbolBoundingData: this.total,
                data: leftData3[1],
                width: 25,
                z: 0,
                zlevel: 3
            },
            {
                //辅助背景图形
                name: "背景条",
                type: "bar", //pictorialBar
                barWidth: "12",
                barGap: "-105%",
                itemStyle: {
                    normal: {
                    borderWidth: 0,
                    color: "#09272C"
                    },
                    barBorderRadius: 10
                },
                data: maxArry,
                z: 0,
                zlevel: 0
            },
        ]
    };// 将你的ECharts配置项放在这里
    chartInstance.setOption(option, true);
}
  window.addEventListener("resize", () => {
    chartInstance.resize();
  });

</script>
<style lang="less"></style>
